"use client";

import { type ReactNode, useState } from "react";

import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerHeader,
  DrawerTrigger,
} from "./drawer";
import Flex from "@/shared/components/common/Flex";
import { debounce } from "@/shared/libs/commonUtils";
import useLocalStorage from "@/shared/hooks/useLocalStorage";
import PhosphorIcon from "../PhosphorIcon";

export interface MobileDrawerProps {
  trigger?: ReactNode;
  renderTrigger?: (onClick: () => void) => ReactNode;
  children: ReactNode;
  page?: "landing" | "result" | "passenger" | "confirm";
}

export default function MobileDrawer({
  children,
  trigger,
  renderTrigger,
  page,
}: MobileDrawerProps) {
  const [drawerIsOpen, setCachedFormData] =
    useLocalStorage<boolean>("drawerOpen");

  const [isOpen, setOpen] = useState(() => {
    const savedState = page === "landing" ? drawerIsOpen : undefined;

    return savedState ? savedState : false;
  });

  const handleClose = () => {
    setOpen(false);
    page === "landing" && setCachedFormData(false);
  };

  const handleTriggerClick = () => {
    if (page === "landing") {
      debounce(() => {
        setCachedFormData(true);
        setOpen(true);
      }, 500)();
    } else {
      setOpen(true);
    }
  };

  return (
    <Drawer open={isOpen} dismissible={false}>
      {trigger && (
        <DrawerTrigger onClick={handleTriggerClick}>{trigger}</DrawerTrigger>
      )}
      {renderTrigger?.(handleTriggerClick)}

      <DrawerContent className="!h-[100dvh] !rounded-none">
        <DrawerHeader className="mb-6 mx-auto border-b border-grayColor w-full">
          <DrawerClose onClick={handleClose}>
            <PhosphorIcon name="X" size={20} />
          </DrawerClose>
        </DrawerHeader>
        <Flex className="w-full max-h-[80dvh] overflow-y-auto">{children}</Flex>
      </DrawerContent>
    </Drawer>
  );
}
